exports = module.exports = require("../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, "\n.text-muted {\r\n    color: rgba(0, 0, 0, 0.5);\n}\r\n", ""]);

// exports
